import React from 'react';

function PaymentMethodsSection({
  ars,
  usd,
  className = '',
}) {
  const methods = [
    {
      title: 'Mercado Pago',
      description: ars ? `Desde Argentina · ${ars}` : 'Desde Argentina',
    },
    {
      title: 'Tarjetas crédito / débito',
      description: 'Para todos los países',
    },
    {
      title: 'PayPal',
      description: usd ? `Fuera de Argentina · ${usd}` : 'Fuera de Argentina',
    },
  ];

  return (
    <section className={`bg-background ${className}`}>
      <div className="relative left-1/2 w-screen -translate-x-1/2 overflow-hidden">
        <div className="payment-methods-rail flex w-screen snap-x snap-mandatory gap-0 overflow-x-auto bg-[#D98E73] py-8 pl-4 text-white [scrollbar-width:none] md:grid md:grid-cols-3 md:gap-6 md:overflow-visible md:px-6 md:py-9 [&::-webkit-scrollbar]:hidden">
          {methods.map(({ title, description }) => (
            <div
              key={title}
              className="min-w-[78vw] snap-start pr-8 text-left md:min-w-0 md:pr-0 md:text-center"
            >
              <p className="font-bold uppercase leading-tight tracking-[0.03em]">{title}</p>
              <p className="mt-1 text-sm leading-snug text-white/95 md:text-base">{description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PaymentMethodsSection;
